import {CanDeactivate} from '@angular/router';
import { Observable } from 'rxjs/Rx';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export class UnsavedGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return component.canDeactivate()
  }
}


// WEBPACK FOOTER //
// ./src/app/transfers/unsaved-guard.service.ts